var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCommsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 49,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 60,
    height: 49,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.196 23.221c0-4.817 1.777-9.344 5.008-12.75a1.811 1.811 0 0 0 0-2.462 1.591 1.591 0 0 0-2.333 0c-3.853 4.063-5.974 9.467-5.974 15.212 0 6.83 2.973 13.102 8.158 17.207.296.236.643.35.99.35.501 0 .995-.24 1.32-.696.549-.767.4-1.86-.327-2.435-4.347-3.443-6.84-8.701-6.84-14.426h-.002Zm-8.018-.4c0-7.072 2.611-13.722 7.356-18.725a2.352 2.352 0 0 0 0-3.2 2.07 2.07 0 0 0-3.033 0C3.946 6.751.887 14.54.887 22.822c0 9.844 4.287 18.885 11.759 24.805.386.308.838.455 1.288.455a2.11 2.11 0 0 0 1.717-.902c.712-1 .52-2.418-.428-3.167C8.84 38.956 5.178 31.234 5.178 22.827v-.006Zm16.238.799c0-2.5.921-4.852 2.599-6.619a1.486 1.486 0 0 0 0-2.02 1.307 1.307 0 0 0-1.916 0c-2.187 2.307-3.393 5.375-3.393 8.64 0 3.88 1.69 7.441 4.633 9.775.244.192.53.285.812.285.412 0 .818-.196 1.084-.571.45-.629.33-1.525-.268-2-2.258-1.785-3.551-4.515-3.551-7.488v-.002ZM50.966.77a2.07 2.07 0 0 0-3.036.017c-.834.89-.826 2.321.018 3.198 4.81 5.016 7.46 11.704 7.46 18.835 0 8.406-3.66 16.13-10.045 21.189-.946.75-1.138 2.17-.426 3.167a2.11 2.11 0 0 0 1.718.902c.45 0 .901-.147 1.287-.455C55.414 41.7 59.701 32.66 59.701 22.816c0-8.349-3.101-16.182-8.734-22.051l-.002.006Zm-6.333 7.154a1.588 1.588 0 0 0-2.333.012 1.806 1.806 0 0 0 .012 2.46c3.273 3.414 5.076 7.969 5.076 12.824 0 5.724-2.491 10.983-6.838 14.426-.73.578-.875 1.668-.33 2.435.324.456.82.696 1.322.696.346 0 .694-.112.99-.35 5.184-4.105 8.155-10.378 8.155-17.207 0-5.792-2.151-11.225-6.056-15.296h.002Zm-6.196 7.006a1.307 1.307 0 0 0-1.914.013 1.482 1.482 0 0 0 .012 2.02c1.7 1.77 2.638 4.136 2.638 6.658 0 2.97-1.296 5.703-3.551 7.489-.598.474-.718 1.37-.27 1.999.266.375.672.571 1.083.571.282 0 .568-.093.812-.285 2.945-2.332 4.633-5.895 4.633-9.774 0-3.291-1.222-6.374-3.441-8.691h-.002Zm-8.146 5.336c-1.673 0-3.029 1.43-3.029 3.195 0 1.764 1.356 3.194 3.03 3.194 1.673 0 3.028-1.43 3.028-3.194 0-1.765-1.355-3.195-3.029-3.195Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M.887.117h58.814v48H.887z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M39.587-4.672H59.7v31.416L39.587-4.672Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 30.294,
    x2: 30.294,
    y1: 0.117,
    y2: 48.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60B5CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 46.384,
    x2: 59.551,
    y1: -3.983,
    y2: 26.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2581C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2266B3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 60.114,
    height: 71.416,
    x: 19.587,
    y: -24.672,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_413_76",
    stdDeviation: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCommsSmall);
export default __webpack_public_path__ + "static/media/logo-comms-small.f95734ae3511aa042923ed8c1a67ea1b.svg";
export { ForwardRef as ReactComponent };